import { render, staticRenderFns } from "./ExtraDialog.vue?vue&type=template&id=9520d2da&scoped=true"
import script from "./ExtraDialog.vue?vue&type=script&lang=js"
export * from "./ExtraDialog.vue?vue&type=script&lang=js"
import style0 from "./ExtraDialog.vue?vue&type=style&index=0&id=9520d2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9520d2da",
  null
  
)

export default component.exports